function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.789062 20.1912V6.34509H22.7121V20.1912C22.7121 21.4605 21.6737 22.4989 20.4044 22.4989H3.09675C1.82752 22.4989 0.789062 21.4605 0.789062 20.1912Z",
  fill: "#CFD8DC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7121 4.03743V7.49897H0.789062V4.03743C0.789062 2.7682 1.82752 1.72974 3.09675 1.72974H20.4044C21.6737 1.72974 22.7121 2.7682 22.7121 4.03743Z",
  fill: "#F44336"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9432 5.76824C17.899 5.76824 18.6739 4.99335 18.6739 4.03747C18.6739 3.08159 17.899 2.3067 16.9432 2.3067C15.9873 2.3067 15.2124 3.08159 15.2124 4.03747C15.2124 4.99335 15.9873 5.76824 16.9432 5.76824Z",
  fill: "#B71C1C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.55841 5.76818C7.51428 5.76818 8.28918 4.99329 8.28918 4.03741C8.28918 3.08153 7.51428 2.30664 6.55841 2.30664C5.60253 2.30664 4.82764 3.08153 4.82764 4.03741C4.82764 4.99329 5.60253 5.76818 6.55841 5.76818Z",
  fill: "#B71C1C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9428 -0.0010376C16.3081 -0.0010376 15.7889 0.518193 15.7889 1.15281V4.03742C15.7889 4.67204 16.3081 5.19127 16.9428 5.19127C17.5774 5.19127 18.0966 4.67204 18.0966 4.03742V1.15281C18.0966 0.518193 17.5774 -0.0010376 16.9428 -0.0010376ZM6.55814 -0.0010376C5.92353 -0.0010376 5.4043 0.518193 5.4043 1.15281V4.03742C5.4043 4.67204 5.92353 5.19127 6.55814 5.19127C7.19276 5.19127 7.71199 4.67204 7.71199 4.03742V1.15281C7.71199 0.518193 7.19276 -0.0010376 6.55814 -0.0010376Z",
  fill: "#B0BEC5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4043 9.80664H7.71199V12.1143H5.4043V9.80664ZM8.86584 9.80664H11.1735V12.1143H8.86584V9.80664ZM12.3274 9.80664H14.6351V12.1143H12.3274V9.80664ZM15.7889 9.80664H18.0966V12.1143H15.7889V9.80664ZM5.4043 13.2682H7.71199V15.5759H5.4043V13.2682ZM8.86584 13.2682H11.1735V15.5759H8.86584V13.2682ZM12.3274 13.2682H14.6351V15.5759H12.3274V13.2682ZM15.7889 13.2682H18.0966V15.5759H15.7889V13.2682ZM5.4043 16.7297H7.71199V19.0374H5.4043V16.7297ZM8.86584 16.7297H11.1735V19.0374H8.86584V16.7297ZM12.3274 16.7297H14.6351V19.0374H12.3274V16.7297ZM15.7889 16.7297H18.0966V19.0374H15.7889V16.7297Z",
  fill: "#90A4AE"
});

function SvgCalendarColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarColor);
export default __webpack_public_path__ + "static/media/calendar-color.08eb234eb92ff4dd4c9abeb1038553b9.svg";
export { ForwardRef as ReactComponent };